export const ArchivesRoutes = {
    registration: {
        root: "/archives",
        archivesDetails: "/archives/:workspaceId",
        auth: "/archives/auth"
    },
    api: {
        baseUrl: "/api/archives"
    }
};
